import { View, ProgressView, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { CuprosterWidget } from "../../../widgets/View/VfWidget/CuprosterWidget";
import { RosterWidget } from "../../../widgets/View/VfWidget/RosterWidget";



export class PostCupOverlay extends View {

    cuprosterWidget: CuprosterWidget;
    progressView: ProgressView;

    constructor( options ) {
        options = options || {};
        super( options );

        this.cuprosterWidget = null;

        if( srvg.widgets.enabled ) {
            // Cuproster widget, if it is enabled in configuration file, while livetable league is not
            if (srvg.widgets.widgets['cuproster'].enabled) {
                this.cuprosterWidget = this.addSubView(new CuprosterWidget({
                    selector: '#post_cup_overlay .tournamentroster',
                    platform: PLATFORM_OVERLAY_SMALL,
                    showTeamAbbr: false,
                    widgetGroup: 'VF'
                }));
            } else if (srvg.widgets.widgets['roster'].enabled) {
                this.cuprosterWidget = this.addSubView(new RosterWidget({
                    selector: '#post_cup_overlay .tournamentroster',
                    platform: PLATFORM_OVERLAY_SMALL,
                    showTeamAbbr: false,
                    widgetGroup: 'VF'
                }));
            }
        }
        this.progressView = this.addSubView( new ProgressView( { selector: this.selector + ' .progressView'} ) );
    }
}